import { render, staticRenderFns } from "./bufenFuKuan.vue?vue&type=template&id=f2c832ce&scoped=true&"
import script from "./bufenFuKuan.vue?vue&type=script&lang=js&"
export * from "./bufenFuKuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c832ce",
  null
  
)

export default component.exports